import React from "react";
import { Link } from "react-router-dom";
import MarketingShell from "@/components/marketing/MarketingShell";
import SoftImage from "@/components/SoftImage";
import { ArrowRight, Check } from "lucide-react";

export default function MarketingPage({ eyebrow, title, highlight, intro, hero, features = [], stats = [] }) {
  const parts = highlight ? title.split(highlight) : [title];
  return (
    <MarketingShell>
      <section className="mx-auto max-w-[1320px] px-5 lg:px-8 pt-12 pb-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="fade-in">
            <p className="text-[12px] font-bold tracking-[0.22em] text-[#5b6b86] uppercase">{eyebrow}</p>
            <h1 className="font-display mt-3 text-[40px] lg:text-[48px] leading-[1.08] font-extrabold text-[#10233f]">
              {parts[0]}{highlight && <span className="text-gradient-blue">{highlight}</span>}{parts[1]}
            </h1>
            <p className="mt-4 text-[17px] text-slate-500 max-w-xl">{intro}</p>
            <div className="mt-7 flex gap-4">
              <Link to="/request-demo" className="btn-primary px-7 py-3.5 font-semibold inline-flex items-center gap-2">Request a Demo <ArrowRight size={18} /></Link>
              <Link to="/dashboard" className="btn-ghost-blue px-7 py-3.5 font-semibold">Explore Platform</Link>
            </div>
            <div className="mt-9 flex gap-8">
              {stats.map(([v, l]) => (<div key={l}><div className="font-display text-[26px] font-extrabold text-[#10233f]">{v}</div><div className="text-[13px] text-slate-500">{l}</div></div>))}
            </div>
          </div>
          <div className="relative">
            <div className="absolute inset-0 pbh-hero-glow" />
            <SoftImage src={hero} alt={title} variant="soft" className="h-[420px] w-full rounded-[28px]" />
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-[1320px] px-5 lg:px-8 pb-16">
        <div className="grid md:grid-cols-2 gap-6">
          {features.map(([t, d, id], i) => (
            <div key={i} id={id} className="card-soft card-hover p-7 flex gap-4 scroll-mt-28">
              <span className="h-11 w-11 shrink-0 rounded-2xl bg-[#e8f1ff] grid place-items-center text-[#1a5fd0]"><Check size={20} /></span>
              <div><h3 className="font-display text-[19px] font-bold text-[#10233f]">{t}</h3><p className="mt-1.5 text-[15px] text-slate-500 leading-relaxed">{d}</p></div>
            </div>
          ))}
        </div>
      </section>
    </MarketingShell>
  );
}
